import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ContentsMandatory } from '../../core/models/contents-mandatory';
import { SplashMapService } from '../../core/services/splash-map.service';
import { firebase } from '@firebase/app';
import { Constants } from '../../core/config/Constants';

@Component({
  selector: 'app-splash-header',
  templateUrl: './splash-header.component.html',
  styleUrls: ['./splash-header.component.css'],
  providers:[SplashMapService]
})
export class SplashHeaderComponent implements OnInit {
  @Input() eventId: string;

  @Output() splashHeaderEvent = new EventEmitter<SplashHeaderData>();

  imageFile = File;
  uploadFileName:string = null;
  uploadprogress:number = null;
  message:string=null;
  headerFileUrl: string;
  fileName:string=null;


  splashHeaderData = new SplashHeaderData();

  constructor(private splashMapService: SplashMapService) { }

  ngOnInit() {
    this.splashMapService.getSplashData(this.eventId).subscribe(event=>{
      if(event) {
       console.log(event);
       if(event.splash_header_image_cm_id){
        this.splashMapService.getFileUrl(this.eventId, event.splash_header_image_cm_id).subscribe(res => {
          if(res) {
            this.headerFileUrl = res.fileUrl;
            this.fileName = res.filename;
          }
        });
        this.splashHeaderData.splash_header_image_cm_id = event.splash_header_image_cm_id;
       }
        this.splashHeaderData.splash_has_header_text_top = event.splash_has_header_text_top;
        this.splashHeaderData.splash_has_header_text_bottom = event.splash_has_header_text_bottom;
        this.splashHeaderData.splash_header_text_top = event.splash_header_text_top;
        this.splashHeaderData.splash_header_text_bottom = event.splash_header_text_bottom;
      }
    });
  }

  onBasicUpload(event) {
    if(event.files[0]) {
      this.splashHeaderData.fileName = event.files[0].name;
      this.splashHeaderEvent.emit(this.splashHeaderData);
      let uploadTask = this.splashMapService.uploadFile(this.eventId,event.files[0]);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) =>  {
          this.splashHeaderData.disableButton = false;
          this.uploadFileName = event.files[0].name;
          this.uploadprogress = Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100);
          this.splashHeaderData.processing = this.uploadprogress;
          this.splashHeaderEvent.emit(this.splashHeaderData);
        },
        (error) => {
          this.splashHeaderEvent.emit(null);
        },
        () => {
          let contentsMandatory = new ContentsMandatory();
          contentsMandatory.category = Constants.CONTENT_M_TYPE_SPLASH;
          contentsMandatory.fileUrl = uploadTask.snapshot.downloadURL;
          contentsMandatory.eventId = this.eventId;
          contentsMandatory.filename = event.files[0].name;
          contentsMandatory.extension = event.files[0].name.split('.').pop();
          contentsMandatory.sizeInBytes = event.files[0].size;
          console.log(contentsMandatory);
         let key = this.splashMapService.addContentMandatory(contentsMandatory);
         if(key) {
          this.splashHeaderData.disableButton = true;
          this.splashHeaderData.splash_header_image_cm_id = key;          
          this.splashHeaderEvent.emit(this.splashHeaderData);
          setTimeout(function() {
            this.message = null;
          }.bind(this), 1000);
        }
         
        }
      );
    }

  }

  handleChange(e) {
    if(e.target.checked) {
      this.splashHeaderData.splash_has_header_text_top = true;
      this.splashHeaderEvent.emit(this.splashHeaderData);
    } else {
      this.splashHeaderData.splash_has_header_text_top = false;
      this.splashHeaderEvent.emit(this.splashHeaderData);
    }
  }

  handleChange1(e) {
    if(e.target.checked){
      this.splashHeaderData.splash_has_header_text_bottom = true;
      this.splashHeaderEvent.emit(this.splashHeaderData);
    } else {
      this.splashHeaderData.splash_has_header_text_bottom = false;
      this.splashHeaderEvent.emit(this.splashHeaderData);
    }
  }

  deleteImage() {
    this.uploadFileName = null;
    this.uploadprogress = null;
  }

  getHeaderText() {
    this.splashHeaderEvent.emit(this.splashHeaderData);
  }
}

export class SplashHeaderData {

  disableButton:boolean=false;
  fileName:string = null;
  processing: number = 0;
  splash_header_image_cm_id:string=null;
  splash_has_header_text_top:boolean=true;
  splash_has_header_text_bottom:boolean=true;
  splash_header_text_top:string=null;
  splash_header_text_bottom:string=null;
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/layout/splash-header/splash-header.component.ts